function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import { GALLERY_CONSTS } from 'pro-gallery-lib';
import INFO_EVENTS from '../../common/constants/infoEvents';
import { window } from '@wix/photography-client-lib';
import DownloadIcon from '../svgs/components/download';

var Download = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Download, _React$Component);

  function Download(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.onDownloadClick = _this.onDownloadClick.bind(_assertThisInitialized(_this));
    _this.onDownloadKeyPress = _this.onDownloadKeyPress.bind(_assertThisInitialized(_this));
    _this.onDownloadImageVideoKeyPress = _this.onDownloadImageVideoKeyPress.bind(_assertThisInitialized(_this));
    _this.onDownloadTextKeyPress = _this.onDownloadTextKeyPress.bind(_assertThisInitialized(_this));
    _this.getAdditionalAttributes = _this.getAdditionalAttributes.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = Download.prototype;

  _proto.onDownloadImageVideoKeyPress = function onDownloadImageVideoKeyPress(e, downloadLink) {
    switch (e.keyCode || e.charCode) {
      case 32: // space

      case 13:
        // enter
        e.stopPropagation();
        e.preventDefault();
        window.open(downloadLink, '_blank');
        this.props.actions.eventsListener(INFO_EVENTS.DOWNLOAD_BUTTON_CLICKED, this.props);
        return false;

      default:
        break;
    }
  };

  _proto.onDownloadTextKeyPress = function onDownloadTextKeyPress(e) {
    switch (e.keyCode || e.charCode) {
      case 32: // space

      case 13:
        // enter
        e.stopPropagation();
        e.preventDefault();
        this.props.actions.eventsListener(INFO_EVENTS.TEXT_DOWNLOAD_BUTTON_CLICKED, this.props);
        return false;

      default:
        break;
    }
  };

  _proto.onDownloadClick = /*#__PURE__*/function () {
    var _onDownloadClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, downloadLink) {
      var _this$props, type, isDemo, actions, customDownloadUrl, downloadUrl, _this$props2, url, photoId, ref;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = this.props, type = _this$props.type, isDemo = _this$props.isDemo, actions = _this$props.actions, customDownloadUrl = _this$props.customDownloadUrl;

              if (!(type === 'text')) {
                _context.next = 7;
                break;
              }

              e.stopPropagation();
              e.preventDefault();
              actions.eventsListener(INFO_EVENTS.TEXT_DOWNLOAD_BUTTON_CLICKED, this.props);
              _context.next = 27;
              break;

            case 7:
              if (isDemo) {
                _context.next = 27;
                break;
              }

              // not text && not Demo
              e.stopPropagation();
              e.preventDefault();
              downloadUrl = downloadLink;

              if (!customDownloadUrl) {
                _context.next = 25;
                break;
              }

              _this$props2 = this.props, url = _this$props2.url, photoId = _this$props2.photoId;
              _context.prev = 13;
              _context.next = 16;
              return customDownloadUrl(url, photoId);

            case 16:
              downloadUrl = _context.sent;

              if (downloadUrl) {
                ref = window.open('', '_blank');
                ref.document.location.href = downloadUrl;
              }

              _context.next = 23;
              break;

            case 20:
              _context.prev = 20;
              _context.t0 = _context["catch"](13);
              console.error('Failed to get custom download url', _context.t0);

            case 23:
              _context.next = 26;
              break;

            case 25:
              window.open(downloadUrl, '_blank');

            case 26:
              this.props.actions.eventsListener(INFO_EVENTS.DOWNLOAD_BUTTON_CLICKED, this.props);

            case 27:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[13, 20]]);
    }));

    function onDownloadClick(_x, _x2) {
      return _onDownloadClick.apply(this, arguments);
    }

    return onDownloadClick;
  }();

  _proto.onDownloadKeyPress = function onDownloadKeyPress(e, downloadLink) {
    var _this$props3 = this.props,
        type = _this$props3.type,
        isDemo = _this$props3.isDemo;

    if (type === 'text') {
      this.onDownloadTextKeyPress(e);
    } else if (!isDemo) {
      this.onDownloadImageVideoKeyPress(e, downloadLink);
    }
  };

  _proto.getAdditionalAttributes = function getAdditionalAttributes(downloadLink) {
    if (this.props.type === 'text') {
      return {};
    }

    var additionals = {
      download: 'download'
    };

    if (!this.props.isDemo) {
      additionals.target = '_blank';
      additionals.href = downloadLink;
    }

    return additionals;
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props4 = this.props,
        styleParams = _this$props4.styleParams,
        isDemo = _this$props4.isDemo,
        createUrl = _this$props4.createUrl;
    var downloadClassName = 'info-member info-element-social-download ' + (styleParams.allowSocial ? '' : ' pull-right ') + ' info-element-social-button';
    var downloadIcon = /*#__PURE__*/React.createElement("i", {
      className: isDemo ? ' inactive' : ''
    }, /*#__PURE__*/React.createElement(DownloadIcon, {
      size: "20"
    }));
    var downloadUrl = styleParams.isStoreGallery ? GALLERY_CONSTS.urlSizes.DOWNLOAD_SAMPLE : GALLERY_CONSTS.urlSizes.DOWNLOAD;
    var downloadLink = createUrl(downloadUrl, GALLERY_CONSTS.urlTypes.VIDEO) || createUrl(downloadUrl, GALLERY_CONSTS.urlTypes.HIGH_RES);
    return /*#__PURE__*/React.createElement("div", _extends({
      className: downloadClassName,
      "data-hook": "item-download",
      "aria-label": "Download",
      role: "button",
      tabIndex: styleParams.isSlideshow && this.props.currentIdx === this.props.idx ? 0 : -1,
      onClick: function onClick(e) {
        return _this2.onDownloadClick(e, downloadLink);
      },
      onKeyDown: function onKeyDown(e) {
        return _this2.onDownloadKeyPress(e, downloadLink);
      }
    }, this.getAdditionalAttributes(downloadLink)), downloadIcon);
  };

  return Download;
}(React.Component);

export default Download;